var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPdf = function SvgPdf(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-32": 24,
    "data-width-36": 27,
    "data-width-40": 30,
    viewBox: "0 0 11.8 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 11.667h8.667a1.5 1.5 0 0 0 1.533-1.5V4.42a1.83 1.83 0 0 0-.54-1.333L8.613.54A1.83 1.83 0 0 0 7.28 0H1.5A1.5 1.5 0 0 0 0 1.5v8.667a1.5 1.5 0 0 0 1.5 1.5M1.148 1.149A.5.5 0 0 1 1.5 1h5.78a.84.84 0 0 1 .593.247l2.547 2.547a.83.83 0 0 1 .247.593v5.78a.507.507 0 0 1-.5.5H1.5a.506.506 0 0 1-.5-.5V1.5a.5.5 0 0 1 .148-.351m1.485 3.798h.834a1.053 1.053 0 1 1 0 2.107H3.02v.613a.387.387 0 0 1-.658.273.38.38 0 0 1-.109-.273V5.334a.38.38 0 0 1 .38-.387M3.02 6.28h.447a.28.28 0 0 0 0-.56H3.02zM5.9 8.054h-.733a.38.38 0 0 1-.38-.387V5.334a.38.38 0 0 1 .38-.387H5.9a1.293 1.293 0 0 1 1.267 1.287v.533A1.293 1.293 0 0 1 5.9 8.054m-.38-.774h.38a.513.513 0 0 0 .52-.513v-.533a.513.513 0 0 0-.52-.514h-.38zm4.013-1.673a.39.39 0 0 1-.273.113h-.98v.394h.887a.387.387 0 1 1 0 .773h-.86v.78a.38.38 0 0 1-.38.387.387.387 0 0 1-.387-.387V5.334a.387.387 0 0 1 .387-.387H9.26a.387.387 0 0 1 .273.66",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export default ForwardRef;